import _ from 'lodash'

const baseController = 'categoriasnutricionales'

const baseIndex = baseController + '/index'

const archetype = [
     // [hidden|number|price|phone|textarea|positivo|password|email]
    {
        key: 'id_pk',
        type: 'hidden'
    },
    [
        {
            key: 'nombre',
        }
    ]
];

const captions = [
    {key: 'categoria'},
    {key: 'ultima_actualizacion', label: 'Última actualización'},
    {key: '_'},
]

let automodalHandler = (conceptId) => {
    let str = baseController + '/' + 'define' + ((_.isNil(conceptId)) ? '' : ('/' + conceptId) );
    // console.log("isNil", _.isNil(conceptId))
    return str;
}


export {
    archetype,
    captions,
    baseIndex,
    automodalHandler
}